import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${({ theme }) => theme.background || '#ffffff'};
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

export const WrapperContainer = styled.div`
  color: ${({ theme }) => theme.text};
  max-width: 1200px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 73px;
  font-family: 'Pretendard', sans-serif;
  padding-bottom: 120px;

  @media (max-width: 1240px) {
    padding: 0 20px;
  }
`;
